export const BASE_URL: string = import.meta.env.VITE_BASE_URL || "https://dummyjson.com/products"
